import { Injectable, EventEmitter } from "@angular/core";
import { Observable } from "rxjs";
import { AppConfig } from "../dto/app-config.model";

@Injectable({
  providedIn: "root"
})
export class SysConfigService {
  // public static APP_ENDPOINT = "api/";
  // public static APP_IP = "192.168.10.9:";
  // public static APP_PROTOCOL = "http://";
  //original
  // public static APP_PORT = "9095/";
  //test env
  // public static APP_PORT = "7075/";
  // public static APP_PORT1 = "10002/";

  public static APP_ENDPOINT = "api/";
  public static APP_IP = "localhost:";
  public static APP_PROTOCOL = "http://";
  public static APP_PORT = "7075/";
  public static APP_PORT1 = "8089/";

  // public static readonly BASE_URL =
  //   SysConfigService.APP_PROTOCOL +
  //   SysConfigService.APP_IP +
  //   SysConfigService.APP_PORT +
  //   SysConfigService.APP_ENDPOINT;
  //
  // public static readonly BASE_URL2 =
  //   SysConfigService.APP_PROTOCOL +
  //   SysConfigService.APP_IP +
  //   SysConfigService.APP_PORT1 +
  //   SysConfigService.APP_ENDPOINT;

  getConfig = new EventEmitter<AppConfig>();

  constructor() {}

  set config(value) {
    window.sessionStorage.setItem("appConfig", JSON.stringify(value));
    this.getConfig.emit(value);
  }

  get config(): any | Observable<any> {
    return JSON.parse(window.sessionStorage.getItem("appConfig"));
  }
}
